import src from "IMAGE";
export default { src, width: 1024, height: 918, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/webp;base64,UklGRlQAAABXRUJQVlA4TEgAAAAvB4ABAM1VICICHgjICQAAAICjgIUAAAAZAAAAAAAAAAAAAAAAAAAAAAAAAAAECAAAEFjBwKMAACIiN/+8kejMFaj0VpH5MB4="};
